import React, { forwardRef } from "react";

import { StyledJsonFieldWrapper } from "./jsonField.style";
import GenericInputField, {
  TYPES,
} from "../../../../genericInputFields/genericInputField";
import { useFormContext } from "react-hook-form";

const JsonField = forwardRef(({ required, name, label }, ref) => {
  const { control } = useFormContext();
  return (
    <StyledJsonFieldWrapper ref={ref}>
      <GenericInputField
        type={TYPES.JSON_FIELD}
        control={control}
        name={name}
        required={required}
        label={label}
      />
    </StyledJsonFieldWrapper>
  );
});
JsonField.displayName = "JsonField";

export default JsonField;
